import { Button } from "baseui/button";
import "./login.css";
import { useSignIn } from "react-auth-kit";
import { useFormik } from "formik";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated } from 'react-auth-kit';
import { useSignOut } from "react-auth-kit";
import Simulator from "./Simulator.js";
import SimulatorIframe from "./SimulatorIframe.js";
import { ProductCatalog } from './catalogo-screen';
import JerseyBirdPage from './components/JerseyBirdPage';

import $ from "jquery";

// Lê o token de autenticação (localStorage.token ou cookie _auth do react-auth-kit)
function getAuthToken() {
  const lt = localStorage.getItem("token");
  if (lt) return lt;
  const match = document.cookie.match(/(?:^|;\s*)_auth=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

// Remove o cookie _auth do react-auth-kit (limpa a sessão antiga)
function clearAuthCookie() {
  document.cookie = "_auth=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}


function Login(props: any) {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const signIn = useSignIn();
  const isAuthenticated = useIsAuthenticated();
  const singOut = useSignOut();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  // ── Valida sessão existente antes de decidir mostrar Simulator/login ──
  // Sessões antigas (token assinado com o segredo anterior / projeto copiado)
  // são invalidadas pelo backend e aqui limpamos cookies + localStorage.
  const [sessionChecked, setSessionChecked] = useState(false);
  const [sessionValid, setSessionValid] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const token = getAuthToken();
        if (!token) throw new Error("no-token");
        const BACKEND_URL =
          process.env.REACT_APP_BACKEND_URL || "http://localhost:4000/api";
        const r = await axios.get(`${BACKEND_URL}/session`, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 8000,
        });
        const valid = !!(r.data && r.data.success);
        if (!valid) throw new Error("invalid-session");
        setSessionValid(true);
      } catch {
        clearAuthCookie();
        localStorage.clear();
        setSessionValid(false);
        try { singOut(); } catch { /* noop */ }
      } finally {
        // Revela o body SEMPRE (o index.html inicia com visibility:hidden).
        // Antes isso só acontecia quando NÃO autenticado; no reload já logado
        // o body ficava oculto => tela branca.
        document.body.style.visibility = "visible";
        document.body.style.opacity = "1";
        setSessionChecked(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  document.body.style.display = "block";
  setTimeout(() => {
    document.body.style.opacity = "1";
  }, 1000);


  const logout = () => {
    singOut();
    window.open(window.location.origin + "/", "_self");
    //navigate("/");
  };

  (window as { [key: string]: any })["singOut"] = function () {
    singOut();
  }

  const onSubmit = async (values: any) => {
    setError("");

    const payload = {
      ...values,
      email: values.email.trim().toLowerCase(), // ← garante lowercase e remove espaços
    };

    try {
      const BACKEND_URL =
        process.env.REACT_APP_BACKEND_URL || "http://localhost:4000/api";

      const response = await axios.post(`${BACKEND_URL}/verify`, payload, {
        timeout: 8000,
      });

      const userData = response.data.data;

      if (!response.data.success || !userData) {
        throw new Error("Credenciais inválidas");
      }

      // ✅ Salva dados localmente
      localStorage.setItem("user_id", userData.userId);
      localStorage.setItem("user_data", JSON.stringify(userData));
      localStorage.setItem("user_name", userData.userName);
      localStorage.setItem("user_email", userData.userEmail);
      localStorage.setItem("token", response.data.token);




      $("#loading").css("display", "flex");

      // ✅ Faz login
      signIn({
        token: response.data.token,
        expiresIn: 259200,
        tokenType: "Bearer",
        authState: { email: values.email },
      });

      setSessionValid(true);
    } catch (err: unknown) {
      console.error("Erro de login:", err);

      //alert("Erro ao efetuar login. Verifique seus dados ou tente novamente.");

      // Limpa estado local
      localStorage.clear();
      singOut();
      navigate("/");

      if (axios.isAxiosError(err)) {
        const msg =
          (err.response?.data as { message?: string })?.message ||
          (err.code === "ECONNABORTED"
            ? "Tempo de resposta excedido."
            : "Erro de conexão com o servidor.");

        setError(msg);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Erro desconhecido.");
      }
    }

  };


  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit,
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var is_iframe = urlParams.get('i');
  var is_catalog = urlParams.get('site');

  if (is_iframe) {
    (window as any).is_iframe = true;
  } else if (is_catalog) {
    (window as any).is_catalog = true;
  } else {
    (window as any).is_iframe = false;//vai
    (window as any).is_catalog = false;
  }

  /*if (!window.checkedLog && isAuthenticated()) {
    window.checkedLog = true;
    $.ajax({
      url: 'https://api.aistenlab.com/simulator-projects/quota',
      type: 'GET',
      headers: {
        "Authorization": 'Bearer ' + localStorage.getItem("token")
      },
      success: function (data) {
        window.totalQuota = data.max_quota;
      },
      error: function (err) {
        if (isAuthenticated()) {
          //localStorage.clear();
          if (localStorage.getItem("logged") == "1") {
            localStorage.setItem("logged", "0");
            localStorage.setItem("token", "");
            localStorage.setItem("user_type", "");
            localStorage.setItem("user_id", "");
            singOut();

            setTimeout(function () {
              //window.open(window.location.origin + "/", "_self");
            }, 1000);
          }
        }
      }
    })
  }*/

  if (!isAuthenticated()) {
    $("#loading").css("display", "none");
    document.body.style.visibility = "visible";
  }


  return (
    <>

      {is_iframe ? (
        <SimulatorIframe />
      ) : is_catalog ? (
        <div className="text-primary h-full absolute top-0 left-0 z-[10000000000000000000000]" id="landing-iframe2">
          <div className="z-[1000000000000000000] overflow-y-auto max-w-full h-full fixed">
            <JerseyBirdPage initialConfig={null} onConfigChange={null} />
          </div>
        </div>
      ) :
        !sessionChecked ? (
          <div id="login-parent">
            <div id="loginStuff">
              <div className="login-container">
                <div className="login-header">
                  <div id="logoLogin"></div>
                  <h1>Carregando...</h1>
                </div>
              </div>
            </div>
          </div>
        ) :
        (isAuthenticated() && sessionValid !== false) ? (
          <Simulator />
        ) : (

          <div id="login-parent">

            <video id="video-login" width="auto" height="auto" autoPlay={true} loop muted>
              <source src={require('./video.mp4')} type="video/mp4" />
            </video>

            <div id="loginStuff">
              <div className="login-container">
                <div className="login-header">
                  <div id="logoLogin"></div>
                  <h1 className="lang" data-en="Welcome!" data-pt="Bem Vindo!" data-es="Bienvenido!">Bem Vindo!</h1>
                  <p className="lang" data-en="Sign in to continue your journey" data-pt="Faça login para continuar sua jornada" data-es="Inicia sesión para continuar tu viaje">Faça login para continuar sua jornada</p>
                </div>

                <form id="loginForm" onSubmit={formik.handleSubmit}>
                  <div className="form-group">
                    <input
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      name="email"
                      type="email"
                      className="form-input"
                      id="email"
                      placeholder="Email"
                      required
                    ></input>
                    <i className="input-icon fas fa-envelope"></i>
                    <span className="error-message" id="emailError"></span>
                  </div>

                  <div className="form-group password-group flex">
                    <input
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      name="password"
                      type={showPassword ? "text" : "password"}
                      className="form-input"
                      id="password"
                      placeholder="Senha"
                      required
                    />

                    <i className="input-icon fas fa-lock"></i>

                    <button
                      type="button"
                      className="toggle-password m-1 w-[50px]"
                      onClick={() => setShowPassword((v) => !v)}
                      aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                    >
                      <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}></i>
                    </button>

                    <span className="error-message" id="passwordError"></span>
                  </div>


                  <Button isLoading={formik.isSubmitting} type="submit" className="submit-button lang" data-en="Sign In" data-pt="Entrar" data-es="Iniciar sesión">Entrar</Button>


                  {error && (
                    <p style={{ color: 'red', marginTop: '8px', textAlign: 'center' }}>
                      {error}
                    </p>
                  )}

                  <div style={{ textAlign: 'center', marginTop: '12px' }}>
                    <a
                      href="https://mantosfc.com/login"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#aaa', fontSize: '13px', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                      Esqueceu a senha? Clique aqui para redefinir
                    </a>
                  </div>
                </form>

                {/**<div className="divider">
                  <span>or continue with</span>
                </div>

                <div className="social-login">
                  <button className="social-button">
                    <i className="fab fa-google"></i>
                  </button>
                  <button className="social-button">
                    <i className="fab fa-apple"></i>
                  </button>
                  <button className="social-button">
                    <i className="fab fa-github"></i>
                  </button>
                </div>

                <div className="additional-options">
                  <a href="#">Forgot password?</a>
                  <p>
                    Don't have an account?
                    <a href="#">Sign up</a>
                  </p>
                </div> */}
              </div >
            </div >

          </div >
        )
      }
    </>
  );
}

export { Login };